<template>
    <div>
        <div v-if="has_error" v-text="error_text" class="alert alert-danger mb-4"></div>
        <div v-if="is_updated" class="alert alert-success mb-4" v-text="successful_update_text"></div>
        <div class="d-flex align-items-center justify-content-between">
            <div class="col-8">
                <kt-form-group>
                    <kt-form-label>
                        {{ $t("label.referer") }}
                    </kt-form-label>
                    <div class="input-group mb-3 col-12">
                        <v-select
                            v-model="new_referer"
                            @input="setSelectedForUser"
                            class="vSelect form-control"
                            :options="referersOptions"
                            :filterable="false"
                            @search="onSearchUser"
                            :getOptionLabel="(option) => option.id"
                        >
                            <template slot="no-options"> معرف مورد نظر را انتخاب کنید</template>
                            <template slot="option" slot-scope="options">
                                <div class="d-flex align-items-center">
                                    {{ options.title }}
                                </div>
                            </template>
                            <template slot="selected-option" slot-scope="options">
                                <div class="selected d-flex align-items-center">
                                    {{ options.title }}
                                </div>
                            </template>
                        </v-select>
                    </div>
                </kt-form-group>
            </div>
            <div class="col-4">
                <button type="button"
                        class="btn btn-success ml-3"
                        id="update_referer_list_button"
                        @click="updateRefererList()"
                        v-text="$t('btn.submit_changes')">
                </button>
                <button type="button"
                        class="btn btn-danger"
                        id="delete_all_button"
                        @click="deleteAllReferers()"
                        v-text="$t('btn.delete_all')">
                </button>
            </div>
        </div>
        <div class="line-divider mt-4 mb-3"></div>
        <div class="input-group mb-3 col-12">
            <kt-form-group>
                <kt-form-label for="api_key_expire_date">
                    {{ $t('marketing.paystar_percent') }}
                </kt-form-label>
                <kt-form-control dir="ltr" v-model="paystarPercent"
                                 name="paystar_percent"
                                 disabled id="paystar_percent"></kt-form-control>
            </kt-form-group>
        </div>

        <RefererTable :referer_list="referer_list" :has_error="has_error" :error_text="error_text"></RefererTable>
        <AddReferer :referer_list="referer_list" :new_referer="new_referer"  @reset-referer="resetNewReferer" @add-referer="addNewReferer"></AddReferer>
    </div>

</template>

<script>
import {i18n} from '@/plugins/i18n'
import {userService, marketingService} from '@/common/api.service'
import _ from "lodash";
import $ from "jquery";
import toastr from "toastr";
import {KTApp} from "@/plugins/core/app";
import RefererTable from "./referer-table.vue";
import AddReferer from "./add-referer.vue";
import { mapGetters } from "vuex";

export default {
    props: {},
    components: {
        RefererTable,
        AddReferer
    },
    data() {
        return {
            is_updated: false,
            successful_update_text: '',
            has_error: false,
            error_text: '',
            new_referer: {
                referer_percent: 1
            },
            referer_list: [],
            referersOptions: [],
            marketingStatuses: [
            { name: this.$t("label.active_marketing_status"), value: 1 },
            { name: this.$t("label.inactive_marketing_status"), value: 0 },
        ],
        };
    },
    computed: {
        ...mapGetters("user", ["user", "status"]),
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false,
            };

            return toastr;
        },
        sumOfPercents() {
            let result = 0;

            for (let i = 0; i < this.referer_list.length; ++i) {
                result += this.referer_list[i].referer_percent;
            }

            return result;
        },
        paystarPercent() {
            return 100 - this.sumOfPercents
        }
    },
    mounted() {
        this.getUserRefererList()
    },
    methods: {
        handleStatusChange() {
            let params = {
                'hashid': this.$route.params.hashid,
                'status': this.user.marketing_status
            };
            marketingService.changeStatus(params)
                .then(response => {
                    this.toastr.success('وضعیت همکاری در فروش کاربر با موفقیت تغییر کرد.')
                })
                .catch(error => {
                    this.toastr.error(error)
                });
        },
        getUserRefererList() {
            marketingService
                .fetchUserRefererList(this.$route.params.hashid)
                .then((res) => {
                    this.referer_list = res.data.data
                    this.referer_list.map(function (ref) {
                        ref.referer_percent = parseFloat(ref.referer_percent);
                    })
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        openAddNewRefererModal() {
            $('#add_new_referer_modal').modal('toggle');
        },
        deleteAllReferers() {
            let delete_all = window.confirm(i18n.t('marketing.delete_all_referers_confirm'));

            if (delete_all) {
                this.has_error = false;
                this.error_text = ''
                this.referer_list = [];
            }
        },
        updateRefererList() {
            let btn = $('#update_referer_list_button')
            this.is_updated = false;
            this.has_error = false;
            let referer_list = [];
            if (this.sumOfPercents > 100) {
                this.error_text = i18n.t('marketing.sum_percents_error');
                this.has_error = true;
            }
            for (let i = 0; i < this.referer_list.length; ++i) {
                referer_list.push({
                    referer_id: this.referer_list[i].id,
                    referer_percent: this.referer_list[i].referer_percent,
                    marketing_profit_type: this.referer_list[i].marketing_profit_type,
                });
            }

            let params = {
                'referer_list': referer_list,
                'user_id': this.$route.params.hashid
            };
            KTApp.progress(btn)

            marketingService.adminUpdateUserReferList(params).then(response => {
                this.getUserRefererList()
                this.successful_update_text = response.data.message;
                this.has_error = false;
                this.is_updated = true;
            }).catch(error => {
                this.is_updated = false;
                this.error_text = i18n.t('message.an_error_occurred');
                this.has_error = true;
            }).finally(() => {
                KTApp.unprogress(btn)
            });
        },
        initSelectPicker() {
            setTimeout(() => {
                $('.kt-selectpicker').selectpicker({
                    size: 4,
                    liveSearch: true,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_selected')
                });
            }, 2000);
        },
        setSelectedForUser(value) {
            this.new_referer.id = value ? value.id : null;
            this.new_referer.title = value ? value.title : null;
            if (value) {
                this.openAddNewRefererModal();
            }
        },
        onSearchUser(search, loading) {
            this.searchForUser(loading, search, this);
        },
        searchForUser: _.debounce((loading, search, vm) => {
            userService
                .fetchReferers({q: search})
                .then((res) => {
                    vm.referersOptions = res.data;
                    loading(false);
                })
                .catch((e) => {
                    console.log(e);
                });
        }, 600),
        addNewReferer(referer) {
            this.referer_list.push(referer)
        },
        resetNewReferer() {
            this.new_referer = {
                referer_percent: 1
            };
        },
    }
}
</script>

<style>
.modal .modal-content .modal-header .close:before {
    content: "" !important;
}

.modal .modal-content .modal-header .close {
    font-size: 1.8rem;
    line-height: 0.7;
}

.dropdown.bootstrap-select.form-control.kt-.dropup
.dropdown-menu
.inner
ul.dropdown-menu.inner {
    min-width: initial !important;
}

.vSelect {
    --vs-actions-padding: 0;
    --vs-border-color: #fff;
}

</style>